import React, { useState, Fragment, MouseEvent } from 'react';
import {
  Edit as EditIcon,
  Done as SubmitIcon,
  Close as CancelIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";
import { TextField } from '@material-ui/core';
import LoadingButton from '../Shared/LoadingButton';


export default function Editable(props: {
  size?: "small" | "medium",
  pending?: boolean,
  onDelete?: () => void,
  onSubmit: (newVal: string) => void,
  className?: string,
  value?: string,
  confirm?: string,
  required?: boolean,
}) {
  const { value, onDelete, pending, size, confirm, onSubmit, required } = props;
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value || '');

  const handleSubmit = () => {
    if (required && !text) {
      return;
    }
    onSubmit(text);
    setEditing(false)
  }

  const handleCancel = () => {
    setText(value || '');
    setEditing(false);
  }

  const [width, setWidth] = useState(0);
  const handleEdit = (e: MouseEvent<HTMLButtonElement>) => {
    setEditing(true);
  }

  return (
    <span className={props.className}>
      {!editing &&
        <span ref={span => span && setWidth(span.offsetWidth)}>
          {value}
          <LoadingButton pending={pending} size={size} onClick={handleEdit}>
            <EditIcon />
          </LoadingButton>
          {onDelete &&
            <LoadingButton pending={pending} size={size} onClick={onDelete} confirm={confirm || 'Are you sure?'}>
              <DeleteIcon />
            </LoadingButton>
          }
        </span>
      }
      {editing &&
        <Fragment>
          <TextField error={!text} value={text} onChange={e => setText(e.target.value)} style={{width: `${Math.min(width, 430)}px`}} />
          <LoadingButton pending={pending} size={size} onClick={handleSubmit}>
            <SubmitIcon />
          </LoadingButton>
          <LoadingButton pending={pending} size={size} onClick={handleCancel}>
            <CancelIcon />
          </LoadingButton>
        </Fragment>
      }
    </span>
  )
}